import { replaceJyotishaTopicInUrl } from './jyotishaTopicUrl';
import { canonicalJyotishaTopicId } from './jyotishaTopicCanonical';

/**
 * Navigate to a Jyotisha topic from profile or other pages.
 * @param {string} topicId
 * @param {(page: string) => void} onPageChange
 */
export function navigateToJyotishaTopic(topicId, onPageChange) {
  if (!topicId || !onPageChange) return;
  const id = canonicalJyotishaTopicId(topicId);
  replaceJyotishaTopicInUrl(id);
  onPageChange('jyotisha');
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setTimeout(() => {
    window.dispatchEvent(new CustomEvent('jyotisha-open-topic', { detail: { topicId: id } }));
  }, 150);
}

/**
 * Open a Jyotisha milestone group (e.g. test-knowledge for theory exams).
 * @param {string} groupId
 * @param {(page: string) => void} onPageChange
 */
export function navigateToJyotishaMilestone(groupId, onPageChange) {
  if (!groupId || !onPageChange) return;
  onPageChange('jyotisha');
  window.scrollTo({ top: 0, behavior: 'smooth' });
  setTimeout(() => {
    window.dispatchEvent(new CustomEvent('jyotisha-open-milestone', { detail: { groupId } }));
  }, 150);
}

/**
 * Restore scroll position after topic content loads.
 * @param {number} scrollY
 * @param {number} [delayMs]
 */
export function restoreScrollPosition(scrollY, delayMs = 300) {
  if (!scrollY || scrollY <= 0) return;
  setTimeout(() => {
    window.scrollTo({ top: scrollY, behavior: 'smooth' });
  }, delayMs);
}
